import Component from '../vendor/Component'

export default class ProductCarousel extends Component {
  mount() {
    this.slidesContainer = this._elem.querySelector('[data-product-slides]')
    this.slideElements = this._elem.querySelectorAll('[data-product-slide]')

    if (!this.slidesContainer || this.slideElements.length < 2) return

    this.setupCarousel()
  }

  setupCarousel() {
    if (!window.swiper) return

    const initialIndexDesktop = this.slideElements.length > 2 ? 1 : 0

    this.carousel = new window.swiper(this.slidesContainer, {
      direction: 'horizontal',
      loop: false,
      initialSlide: 0,
      slidesPerView: 2.25,
      spaceBetween: 5,
      slidesPerGroup: 1,
      centeredSlides: false,
      centeredSlidesBounds: false,
      speed: 500,
      navigation: {
        nextEl: this._elem.querySelector('[data-next]'),
        prevEl: this._elem.querySelector('[data-prev]')
      },
      breakpoints: {
        768: {
          slidesPerView: 3.25
        },
        1200: {
          slidesPerView: 4.33
        }
      }
    })
  }
}
